/** Anel de foco visível alinhado ao TextInput (A11Y-086/087/090/099). */
export const focusRingClasses =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-mint-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-page)]'

export const focusRingInvalidClasses =
  'aria-invalid:border-[var(--color-wine-strong)] aria-invalid:focus-visible:ring-[var(--color-wine-strong)]'
